import { useEffect } from 'react';
import { usePageData } from 'state/pageData';
import { useWidget } from 'state/widget/context';
import { BASE_URL } from 'utils/constants';
import {
  injectStylesIntoLinkTag,
  isRunningInIFrame,
  isRunningOnDiscoPage,
} from 'utils/injection';
import 'styles/reset.module.scss';

export default function useThemeStyle() {
  const { reactRoot } = usePageData();
  const {
    state: { domainId, hasTheme },
  } = useWidget();

  useEffect(() => {
    async function installStyles() {
      if (reactRoot) {
        const shadow = reactRoot.getRootNode() as Element;

        if (process.env.NODE_ENV === 'development') {
          // local development mode.  styles can be required based on their filename
          // in the src code.  safe to include fonts.
          require('styles/theme/sharedThemes/defaultTheme/index.scss');
          require('styles/theme/sharedThemes/defaultTheme/fonts.scss');

          if (domainId) {
            const mapping = require('utils/domainMapping');
            const domainName = Object.keys(mapping).find(
              (name) => mapping[name] === domainId,
            );

            if (domainName) {
              require(`styles/theme/${domainName}/fonts.scss`);
              require(`styles/theme/${domainName}/index.scss`);
            }
          }
        } else if (process.env.NODE_ENV === 'production') {
          // production mode (code it built and served from cdn).  styles have to
          // be injected into the dom based on their name created by the build process.
          // fonts should not be downloaded unless the code is running on one of our
          // test pages
          if (domainId) {
            injectStylesIntoLinkTag(
              `${BASE_URL}css/theme/defaultTheme.fonts.css`,
              document.head,
            );

            injectStylesIntoLinkTag(
              `${BASE_URL}css/theme/defaultTheme.css`,
              shadow,
            );

            if (hasTheme) {
              injectStylesIntoLinkTag(
                `${BASE_URL}css/theme/${domainId}.css`,
                shadow,
              );

              // only inject font if we're running on one of our test pages or in an iframe.
              // font should not be downloaded on publisher's page.
              if (isRunningOnDiscoPage() || isRunningInIFrame()) {
                injectStylesIntoLinkTag(
                  `${BASE_URL}css/theme/${domainId}.fonts.css`,
                  document.head,
                );
              }
            }
          }
        }
      }
    }

    installStyles();
  }, [domainId, hasTheme, reactRoot]);
}
